/* eslint-disable */
export default {
  _bonus_round_complete: 'bonus-round-complete',
  _bubbles: 'bubbles',
  _chest: 'chest',
  _click: 'click',
  _correct: 'correct',
  _dance: 'dance',
  _incorrect: 'incorrect',
  _jingle: 'jingle',
  _number_bounce: 'number-bounce',
  _number_off_screen: 'number-off-screen',
  _pop_sound: 'pop_sound',
  _pop: 'pop',
  _pop1: 'pop1',
  _pop10: 'pop10',
  _pop2: 'pop2',
  _pop3: 'pop3',
  _pop4: 'pop4',
  _pop5: 'pop5',
  _pop6: 'pop6',
  _pop7: 'pop7',
  _pop8: 'pop8',
  _pop9: 'pop9',
  _shark: 'shark',
}